module.exports = __webpack_public_path__ + "img/service_information.85a63654.png";